export default {
  statWrapper: { mt: { xs: 3, lg: 1 }, border: 'solid yellow' },
  statItem: {
    maxWidth: 374,
    '&:not(:first-of-type)': { mt: { xs: 1, lg: 0 } },
    pr: 2,
  },
  linkWrapper: { display: 'flex', pt: { xs: 2, xl: 4 } },
  link: {
    textDecoration: 'none',
  },
};
